import "./styles/App.scss";
import { useEffect, useState } from "react";
import Home from "./pages/Home";

const App = () => {
  return (
    <div className="App">
      <main id="main" className="page-content__container">
        <Home />
      </main>
    </div>
  );
};

export default App;
